import { DonationWUT } from '@wix/form-fields/viewer-wut';

export default DonationWUT;
